import React from 'react';
import { Homepage } from './Homepage';
import { ProductHomepage } from './ProductHomepage';
import { jsx as _jsx } from "react/jsx-runtime";
const Home = _ref => {
  let {
    productId
  } = _ref;
  if (productId) {
    return /*#__PURE__*/_jsx(ProductHomepage, {
      productId: productId
    });
  }
  return /*#__PURE__*/_jsx(Homepage, {});
};
export default Home;